import { render, staticRenderFns } from "./RespostaCadastroDadosBasicos.vue?vue&type=template&id=4e0a8af0"
import script from "./RespostaCadastroDadosBasicos.vue?vue&type=script&lang=js"
export * from "./RespostaCadastroDadosBasicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports